import { Link } from "office-ui-fabric-react";

const PresentationModeSettingsTooltip = () => <div>
    In Presentation Mode, a Project Story is displayed in place of the corresponding Dashboard.
    <br />
    Please refer to the <Link href="https://help.ppm.express/89495-ppm-express-settings/522610#section-14" target="_blank">article</Link> for more details.
</div>

export default PresentationModeSettingsTooltip;